import React from 'react';
import { Fragment, useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next/hooks';
import Img from "react-cool-img";

import Button from '../../Button/Button';
import Loader from '../../Loader/Loader';

import { useStore } from '../../../hook-store/store';
import { 
  cancelGroupInvitation,
} from '../../../util/group/group-invitation';

import { SOCKET_GROUP_URL } from '../../../App';

import SampleImage from '../../Image/person-icon-50.jpg';

import '../../../pages/GroupTalk/GroupTalk.css';
import './GroupInvitation.css';

const GroupInvitationList = (props) => {
  // console.log('grouplistItem.js props', props);

  const { 
    group,
    usersData,
    userId,
    isLoading,

    showInvitationModal,
    showInvitationModalHandler,
  } = props;

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { groupInvitationData } = store.groupStore;

  const [selectedUserId, setSelectedUserId] = useState('');
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);


  const cancelGroupInvitationHandler = async (groupRoomId, emailInput) => {
    try {
      setIsDataLoading(true);

      const resData = await cancelGroupInvitation(
        SOCKET_GROUP_URL,
        localStorage.getItem('token'),
        groupRoomId,
        emailInput,
      );

      if (resData) {
        const deletedInvitingUsers = groupInvitationData.invitingUsers.filter(ele => {
          return ele.email !== emailInput;
        });

        dispatch('SET_GROUPINVITATIONDATA', {
          ...groupInvitationData,
          invitingUsers: deletedInvitingUsers,
        });

        dispatch('SHOW_NOTIFICATION', {
          // status: 'pending',
          //   title: '',
          message: 'delete success',
        });
  
        setTimeout(() => {
          dispatch('CLEAR_NOTIFICATION');
        },1000*5);

        setSelectedUserId('');
        setShowDeleteConfirm(false);
      }

      setIsDataLoading(false);
    } catch(err) {
      console.log(err);
      setIsDataLoading(false);
      throw err;
    }
  };

  let groupInvitationListBody;

  if (groupInvitationData?.invitingUsers?.length > 0) {
    groupInvitationListBody = (
      <div>
        <div className='groupInivitationTitle'>
          <strong>
            {t('groupTalk.text48', 'Inviting users')}
          </strong>
        </div>
        <ul className='groupInvitationList'>
          {groupInvitationData.invitingUsers.map(element => {
                        
            const lsNameDataList = localStorage.getItem('lsNameDataList');
            let inviteUserNameData 
            
            if (lsNameDataList) {
              inviteUserNameData = JSON.parse(lsNameDataList).find(ele => {
                return ele.userId === element.userId;
              });
            }

            console.log('inviteUserNameData ', inviteUserNameData)
            
            return (
              <li className='groupInvitationListItem'
                key={element.userId}
              >
                <div className='groupInvitationListItemRow'>
                  <span>
                    {inviteUserNameData && (
                      <div className='groupInvitationListItemNameRow'>
                        {inviteUserNameData.imageUrl && (
                          <Img style={{height: "1.25rem", width:"1.25rem", objectFit: "cover"}}
                            src={inviteUserNameData.imageUrl}
                          />
                        )}
                        {!inviteUserNameData.imageUrl && (
                          <Img style={{height: "1.25rem", width:"1.25rem", objectFit: "cover"}}
                            src={SampleImage}
                          />
                        )}
                        <span>
                          {inviteUserNameData.name}
                        </span>
                      </div>
                    )}
                    <div>
                      {element.email}
                    </div>
                    <div>
                      ({new Date(element.addAt).toLocaleDateString()})
                    </div>
                  </span>
                  <span>
                    <Button 
                      mode="raised" design="" type="submit" size='smaller'
                      disabled={isDataLoading}
                      onClick={() => {
                        setSelectedUserId(element.userId);
                        setShowDeleteConfirm(true);
                      }}
                    >
                        {t('groupTalk.text49', 'Delete')}
                    </Button>
                  </span>
                </div>
                {selectedUserId === element.userId && showDeleteConfirm && (
                    <div>
                      <div className='groupInvitationRow'>
                        {t('groupTalk.text50', 'Delete invitation?')}
                      </div>
                      <div className='groupInvitationButtons'>
                        <Button
                          mode="" design="" type="submit" size='smaller'
                          disabled={isDataLoading}
                          onClick={() => {
                            setSelectedUserId('');
                            setShowDeleteConfirm(false);
                          }}
                        >
                          {t('groupTalk.text51', 'Cancel')}
                        </Button>
                        <Button
                          mode="" design="raised" type="submit" size='smaller'
                          disabled={isDataLoading}
                          onClick={() => {
                            cancelGroupInvitationHandler(
                              group.groupRoomId,
                              element.email,
                            );
                          }}
                        >
                          {t('groupTalk.text49', 'Delete')}
                        </Button>
                      </div>
                      {isDataLoading && (
                        <Loader />
                      )}
                    </div>
                  )}
              </li>
            )
        })}
        </ul>
      </div>
    );
  }

  return (
      <Fragment>
        <div>
          {groupInvitationListBody}
        </div>
      </Fragment>
  );
}

export default GroupInvitationList;